import React from 'react';
import logo from './logo.png';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import '../../app/app.component.css'
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className='footer-background'>
            <div className='footer-container1'>
                <div className='footer-item-1'>
                    <p className='get-connected'>Get connected with us on social networks:</p>
                </div>
                <div className='footer-item-1'></div>
                <div className='footer-socials'>
                    <a href='https://www.instagram.com/royal_princess_parties' target='_blank'><InstagramIcon className='social-icons' /></a>
                    <a href='https://twitter.com/parties_royal' target='_blank'><XIcon className='social-icons' /></a>
                    <a href='https://www.facebook.com/rpp01' target='_blank'><FacebookIcon className='social-icons' /></a>
                </div>
            </div>

            <div className='footer-container2'>
                <div className='footer-item'>
                    <div style={{ textAlign: 'left' }}>
                        <a href='/'><img style={{ height: '60px', width: '170px', marginRight: '-90px', marginTop: '10px' }} src={logo} alt="Logo" /></a>
                    </div>
                </div>
                <div className='footer-item'>
                    <div style={{ textAlign: 'left' }}>
                        <h3>Useful Links</h3>
                        <Link className='footer-links' to="/">Home</Link>
                        <Link className='footer-links' to="/characters">Characters</Link>
                        <Link className='footer-links' to="/pricing">Pricing</Link>
                        <Link className='footer-links' to="/cast">Cast</Link>
                        <Link className='footer-links' to="/contact">Contact</Link>
                    </div>
                </div>
                <div className='footer-item'>
                    <div style={{ textAlign: 'left' }}>
                        <h3>Contact</h3>
                        <p className='footer-text'>Address: <span style={{ fontWeight: 'normal' }}>Northbrook, IL 60062</span></p>
                        <p className='footer-text'>Email: <span style={{ fontWeight: 'normal' }}>
                            <a href="mailto:info@royalprincessparties.com" style={{ textDecoration: 'none', color: 'inherit' }}>
                                info@royalprincessparties.com
                            </a>
                        </span></p>
                        <p className='footer-text'>Phone: <span style={{ fontWeight: 'normal' }}>(773) 800-9046</span></p>
                    </div>
                </div>
            </div>

            {/* New Container for Two Equal Columns */}
            <div className='footer-container3'>
                <div className='footer-column'>
                    <p>Copyright 2023, Royal Princess Parties LLC</p>
                    <p>All images are property of Royal Princess Parties LLC</p>
                </div>
                <div className='footer-column'>
                    <p>We attempt to make our characters different from nationally known, copyrighted characters with uniquely designed costumes and names of our own creation. Any resemblance to nationally known characters is strictly coincidental and unintentional.</p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
